import { FilterOption, FilterRow } from '@/ui/components/FilterRow'
import { SortBy, SortingOption } from '@/ui/components/SortBy'
import { useTranslations } from 'next-intl'
import { cn } from '@/utils/ui'
import React from 'react'

export const ArchiveFiltersAndSort = ({
  filterTitle,
  filter,
  currentFilter,
  onFilterChange,
  isLoading,
  isPending,
  sortingOptions,
  currentSort,
  onSortChange,
  showFilter,
  includeAllFilter,
  filterAppearance,
  analyticsContext,
}: {
  filterTitle: string
  filter: FilterOption[]
  currentFilter: string
  onFilterChange: (filter: string) => void
  isLoading: boolean
  isPending: boolean
  sortingOptions?: SortingOption[]
  currentSort?: string
  onSortChange?: (sort: string) => void
  showFilter: boolean
  includeAllFilter: boolean
  filterAppearance?: 'default' | 'compact' | 'grid'
  analyticsContext?: { filter_category?: string }
}) => {
  const t = useTranslations('public')
  const hasSorting = sortingOptions && sortingOptions.length > 0 && onSortChange

  // Determine the appearance to use
  const appearance = filterAppearance || (hasSorting ? 'compact' : 'default')

  return (
    <div
      className={cn(
        'flex flex-col md:flex-row justify-between gap-4 mb-6',
        // Allow interaction during pending state, but show it's processing
        isLoading ? 'opacity-70 pointer-events-none' : isPending ? 'opacity-85' : '',
        // Full width for grid appearance
        filterAppearance === 'grid' && 'md:flex-col',
      )}
    >
      {showFilter && (
        <FilterRow
          title={filterTitle}
          filters={filter}
          currentFilter={currentFilter}
          onFilterChange={onFilterChange}
          isLoading={isLoading}
          appearance={appearance}
          includeAllFilter={includeAllFilter}
          analyticsContext={analyticsContext}
        />
      )}
      {hasSorting && (
        <SortBy
          title={t('sort-by')}
          sortingOptions={sortingOptions}
          currentSort={currentSort}
          onSortChange={onSortChange}
          isLoading={isLoading}
          className={filterAppearance === 'grid' ? '' : 'md:ml-auto'}
        />
      )}
    </div>
  )
}
